import { __decorate, __metadata } from "tslib";
import { bindingMode } from 'aurelia-binding';
import { bindable, customElement, noView } from 'aurelia-templating';
var MdcPromisifyReference = /** @class */ (function () {
    function MdcPromisifyReference() {
    }
    MdcPromisifyReference.prototype.referenceChanged = function () {
        if (this.reference) {
            this.resolve(this.reference);
        }
    };
    MdcPromisifyReference.prototype.attached = function () {
        var _this = this;
        this.promise = new Promise(function (r) { return _this.resolve = r; });
    };
    __decorate([
        bindable({ defaultBindingMode: bindingMode.fromView }),
        __metadata("design:type", Promise)
    ], MdcPromisifyReference.prototype, "promise", void 0);
    __decorate([
        bindable({ defaultBindingMode: bindingMode.toView }),
        __metadata("design:type", Object)
    ], MdcPromisifyReference.prototype, "reference", void 0);
    MdcPromisifyReference = __decorate([
        customElement('mdc-promisify-reference'),
        noView
    ], MdcPromisifyReference);
    return MdcPromisifyReference;
}());
export { MdcPromisifyReference };
//# sourceMappingURL=mdc-promisify-reference.js.map